import * as actionTypes from './lookupActionType';

export const lookupRequest = (
  lookupType: actionTypes.LookupType,
  request: actionTypes.LookupRequest
): actionTypes.LookupRequestAction => {
  return {
    type: actionTypes.LOOKUP_REQUEST,
    payload: {
      lookupType,
      request,
    },
  };
};

export const lookupSuccess = (
  lookupType: actionTypes.LookupType,
  response: actionTypes.LookupResponse
): actionTypes.LookupSuccessAction => {
  return {
    type: actionTypes.LOOKUP_SUCCESS,
    payload: {
      lookupType,
      response,
    },
  };
};

export const lookupError = (
  lookupType: actionTypes.LookupType,
  message: string,
  error?: any
): actionTypes.LookupErrorAction => {
  return {
    type: actionTypes.LOOKUP_ERROR,
    payload: {
      lookupType,
      message,
      error,
    },
  };
};

export const lookupReset = (
  lookupType: actionTypes.LookupType
): actionTypes.LookupResetAction => {
  return {
    type: actionTypes.LOOKUP_RESET,
    payload: {
      lookupType,
    },
  };
};


